import type React from "react";
import type { InputHTMLAttributes } from "react";
import { tw } from "../../../styling";
import { SvgIcon } from "../../svg-icon";

type Props = { withOutline?: boolean } & InputHTMLAttributes<HTMLInputElement>;

export const Checkbox: React.FC<Props> = ({ checked, disabled, withOutline, ...rest }) => (
	<span
		className={tw(
			`flex w-5 self-center`,
			withOutline &&
				`has-focus-visible:outline-interactive-primary has-focus-visible:rounded-sm has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-solid`,
			disabled && "cursor-not-allowed",
		)}
	>
		<SvgIcon
			imageSrc={checked ? "CHECKBOX_CHECKED" : "CHECKBOX_UNCHECKED"}
			className={disabled ? "text-interactive-disabled" : "text-interactive-primary"}
			height={20}
		/>
		<input type="checkbox" checked={checked} disabled={disabled} {...rest} className="sr-only" />
	</span>
);
